export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7462.0b59e1b4.jpg";